module.exports = __webpack_public_path__ + "img/list.8bb26905.png";